import React from 'react';
import AdminDashboard from '../admin/AdminDashboard';

const AdminDashboardPage = () => {
  return <AdminDashboard />;
};

export default AdminDashboardPage;

